// `react-to-print` normally rebuilds the page's styles inside its print iframe by
// cloning every <style> and <link rel="stylesheet"> element, then waiting for each
// cloned <link> to fire load or error before it opens the print dialog. If one
// never settles the dialog never opens and the library gives up without calling
// `onAfterPrint` or `onPrintError`. Reading the already-parsed rules out of
// `document.styleSheets` instead gives us the same CSS with nothing left to load,
// so printing can be driven with `ignoreGlobalStyles` and no waiting.
const collectStyleSheetRules = () => {
  const rules: string[] = [];

  Array.from(document.styleSheets).forEach((sheet) => {
    try {
      Array.from(sheet.cssRules).forEach((rule) => rules.push(rule.cssText));
    } catch {
      // Browsers block script access to the rules of a cross-origin sheet. The
      // remote font and icon sheets imported by css/index.css land here; the
      // charts don't depend on them, so they are skipped rather than fatal.
    }
  });

  return rules.join('\n');
};

export const getPrintStyles = (width: number, height: number) =>
  `${collectStyleSheetRules()}
    @page { size: ${width}px ${height}px; margin: 0; }
    @media print {
      body {
        color-adjust: exact;
        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
    }
  `;
